import React from 'react';
import classnames from 'classnames';
import { TierPresentationsB } from '../../../../constants/TierPresentations';
import {
	CURRENT,
	ONBOARDING_TIER_OPTIONS_PROMO_PERIOD_PROMO,
	BLACK_FRIDAY,
} from '../../../../constants/Copy';
import { TIER_IDS } from '../../../../constants/Tiers';
import TierList from './TierList';

import './TierDescription.scss';

const TierDescription = ({
	tierId,
	pricing,
	discountedPrice,
	current,
	selected,
	onClick,
	isBlackFriday,
}) => {
	const tierPresentation = TierPresentationsB[tierId];
	const testId = `tierdetails-container--${tierId}`;
	return (
		<article
			className={classnames('tierdescription', { ['tierdescription--selected']: selected })}
			key={tierId}
			onClick={() => onClick && onClick(tierId)}
			data-test={testId}
		>
			{current && (
				<span
					className={classnames('tierdescription__current-label', {
						['tierdescription__current-label--selected']: selected,
					})}
				>
					{CURRENT}
				</span>
			)}
			{isBlackFriday && (
				<span
					className={classnames('tierdescription__current-label promo-deal', {
						['tierdescription__current-label--selected promo-deal--selected']: selected,
					})}
				>
					{BLACK_FRIDAY.TIER_LABEL}
				</span>
			)}
			<div
				className={classnames('tierdescription__header', {
					['tierdescription__header--selected']: selected,
				})}
			>
				<div className="tierdescription__headerContentWrapper">
					<div
						className={classnames('tierdescription__titleWrapper', {
							['tierdescription__titleWrapper--no-label']: !tierPresentation.label,
						})}
					>
						<h2 className="tierdescription__title" data-test="tierdetails-title">
							{tierPresentation.title}
						</h2>
						{tierPresentation.label && (
							<span
								className={classnames('tierdescription__label', {
									['tierdescription__label--selected']: selected,
								})}
								data-test="tierdetails-current"
							>
								{tierPresentation.label}
							</span>
						)}
					</div>
					{isBlackFriday && (
						<span
							className={classnames('tierdescription__header-period', {
								['tierdescription__header-period--selected']: selected,
							})}
						>
							{BLACK_FRIDAY.TIER_PERIOD}
						</span>
					)}
					<div className="tierdescription__headerPricing">
						<span
							className={classnames('tierdescription__headerPricingPrice', {
								['tierdescription__headerPricingPrice--discountedPrice']: discountedPrice,
							})}
						>
							{tierId === TIER_IDS.FREE
								? ONBOARDING_TIER_OPTIONS_PROMO_PERIOD_PROMO
								: `€${pricing}`}
						</span>
						{discountedPrice && (
							<span className="tierdescription__headerPricingPrice">€{discountedPrice}</span>
						)}
						{tierId !== TIER_IDS.FREE && (
							<span className="tierdescription__headerPricingPeriod">/ maand</span>
						)}
					</div>
				</div>
			</div>
			<div className="tierdescription__features" data-test="tierdescription-features">
				<TierList tierFeatures={tierPresentation} />
			</div>
		</article>
	);
};

export default TierDescription;
